import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {BenutzerDTO} from "../../../models/benutzer/BenutzerDTO";
import {FieldConfigService} from "../../../@core/services/field-config/field-config.service";
import {TranslateService} from "@ngx-translate/core";

import {TextbausteinService} from "../../../@core/services/textbaustein/textbaustein.service";
import {EnumHelperService} from "../../../@core/utils/forms/enum-helper.service";
import {KeyString} from "../../../models/textbaustein/KeyString";
import {ConfigService} from "../../../@core/config/services/config.service";

@Component({
    selector: 'app-fahrkosten-detail-parent',
    templateUrl: './fahrkosten-detail-parent.component.html',
    styleUrls: ['./fahrkosten-detail-parent.component.scss'],
    standalone: false
})
export class FahrkostenDetailParentComponent implements OnInit, OnDestroy {

  title = '';
  subtitle='';

  fahrkostenId: string;
  fieldConfig;

  benutzer: BenutzerDTO;
  benutzerRoles: Array<string>;

  subscriptionTranslate: Subscription;

  optionErmaessigung = [];
  optionGeschlecht = [];
  optionWegtyp = [];
  optionSonderfall = [];
  optionBefoerderung = [];
  landList = [];
  portalUrl = '';

  constructor(
    public translateService: TranslateService,
    private readonly route: ActivatedRoute,
    public textbauSteinService: TextbausteinService,
    private readonly fieldConfigService: FieldConfigService,
    private readonly enumHelperService: EnumHelperService,
    private readonly configService: ConfigService
  ) {
    if(this.configService.featureConfig.kommunalportalAuth)
      this.portalUrl = sessionStorage.getItem('portalUrl');
  }

  ngOnInit(): void {
        this.title = this.textbauSteinService.printTextbausteinByKey( KeyString.SUBTITLE_FAHRKOSTEN,
          this.translateService.instant('FAHRKOSTEN-DETAIL.TITLE'));
        this.loadFieldConfig();
        this.setBenutzer();
        this.fahrkostenId = this.route.snapshot.paramMap.get('id');
        this.initHardcodedLists();
        this.initRequiredFields();
  }

  ngOnDestroy() {
    this.subscriptionTranslate.unsubscribe();
  }

  initRequiredFields(){
    let allFormFields = this.fahrkostenFormFields;
    allFormFields.forEach((varName) => {
      let field = this.fieldConfigService.getFieldFromFieldConfig(varName, this.fieldConfig);
      if(!(field)) {
        field = {field: varName, visible: true, required: false, label: null, module: 'fahrkosten'};
      }
      if( field.visible===true || this.alwaysVisible.includes(varName)){
        this.visibleFields = [...this.visibleFields,varName];
        if(!this.neverValidate.includes(varName) &&
          (this.alwaysValidateIfVisible.includes(varName) || field.required===true)){
            this.requiredFields = [...this.requiredFields,varName];
        }
      }
    });
  }

  initHardcodedLists(): void {
    this.subscriptionTranslate = this.translateService.get('dummyTranslation').subscribe(()=>{
      this.optionErmaessigung = [{id: null, name: this.translateService.instant("TICKETDETAIL.ERMAESSIGUNG.KEINE") },
        {id:"ERMAESSIGT", name: this.translateService.instant("TICKETDETAIL.ERMAESSIGUNG.ERMAESSIGT") },
        {id:"ERLASSEN", name: this.translateService.instant("TICKETDETAIL.ERMAESSIGUNG.ERLASSEN") }
      ];
      this.optionGeschlecht = this.enumHelperService.getGeschlechtOptionList();
      this.optionWegtyp = [{id: null, name: "-" },
        {id:"SCHULWEG", name: this.translateService.instant("TICKETDETAIL.WEGTYP.SCHULWEG") },
        {id:"PRAKTIKUMSWEG", name: this.translateService.instant("TICKETDETAIL.WEGTYP.PRAKTIKUMSWEG") },
        {id:"BEIDES", name: this.translateService.instant("TICKETDETAIL.WEGTYP.BEIDES") }
      ];

      this.optionSonderfall = [{value:null, name: this.translateService.instant("TICKETDETAIL.SONDERFALL.NICHT_AUSGEWAEHLT") },
        {value:"SCHWERBEHINDERUNG", name: this.translateService.instant("TICKETDETAIL.SONDERFALL.SCHWERBEHINDERUNG") },
        {value:"INKLUSION_BESONDERE_FOERDERUNG", name: this.translateService.instant("TICKETDETAIL.SONDERFALL.INKLUSION_BESONDERE_FOERDERUNG") },
        {value:"ERKRANKUNG_VERLETZUNG", name: this.translateService.instant("TICKETDETAIL.SONDERFALL.ERKRANKUNG_VERLETZUNG") },
        {value:"ZUWEISUNG_DES_KOMMUNALEN_INTEGRATIONSZENTRUMS", name: this.translateService.instant("TICKETDETAIL.SONDERFALL.ZUWEISUNG_DES_KOMMUNALEN_INTEGRATIONSZENTRUMS") },
        {value:"SCHULEMPFEHLUNG_DES_KOMMUNALEN_INTEGRATIONSZENTRUMS", name: this.translateService.instant("TICKETDETAIL.SONDERFALL.SCHULEMPFEHLUNG_DES_KOMMUNALEN_INTEGRATIONSZENTRUMS") },
        {value:"GYMNASIUM_MIT_GEWAEHLTEM_BILINGUALEN_BILDUNGSGANG", name: this.translateService.instant("TICKETDETAIL.SONDERFALL.GYMNASIUM_MIT_GEWAEHLTEM_BILINGUALEN_BILDUNGSGANG") },
        {value:"SPORTKLASSE_NRW", name: this.translateService.instant("TICKETDETAIL.SONDERFALL.SPORTKLASSE_NRW") },
        {value:"AUSZUBILDENDE_VON_BEZIRKSFACHKLASSEN", name: this.translateService.instant("TICKETDETAIL.SONDERFALL.AUSZUBILDENDE_VON_BEZIRKSFACHKLASSEN") },
        {value:"INTERNAT", name: this.translateService.instant("TICKETDETAIL.SONDERFALL.INTERNAT") },
        {value:"ARBEITSLOSIGKEIT_UND_BERUFSSCHULPFLICHTIGKEIT", name: this.translateService.instant("TICKETDETAIL.SONDERFALL.ARBEITSLOSIGKEIT_UND_BERUFSSCHULPFLICHTIGKEIT") },
        {value:"ABLEHNUNG_NAECHSTGELEGENE_SCHULE_DER_SELBEN_SCHULFORM", name: this.translateService.instant("TICKETDETAIL.SONDERFALL.ABLEHNUNG_NAECHSTGELEGENE_SCHULE_DER_SELBEN_SCHULFORM") },
        {value:"WOHNSITZ_IM_AUSLAND", name: this.translateService.instant("TICKETDETAIL.SONDERFALL.WOHNSITZ_IM_AUSLAND") },
        {value:"SONSTIGES", name: this.translateService.instant("TICKETDETAIL.SONDERFALL.SONSTIGES") },
      ];

      this.optionBefoerderung = [
        {id: 'PKW', name: this.translateService.instant("BEFOERDERUNG.PKW")},
        {id: 'SONSTIGE', name: this.translateService.instant("BEFOERDERUNG.SONST")},
        {id: 'FAHRRAD', name: this.translateService.instant("BEFOERDERUNG.FAHRRAD")},
        {id: 'OEPNV', name: this.translateService.instant("BEFOERDERUNG.OEPNV")},
        //{id: 'SPEZIAL', name: this.translateService.instant("BEFOERDERUNG.SPEZIAL")},
        // Bestandssystem legacy, nicht in Excel
        {id: 'MITFAHRER', name: this.translateService.instant("BEFOERDERUNG.MITFAHRER")},
      ];
      if (this.fieldConfigService.getFieldFromFieldConfig('befoerderungSpezial', this.fieldConfig)?.visible) {
        this.optionBefoerderung = [...this.optionBefoerderung, {id: 'SPEZIAL', name: this.translateService.instant("BEFOERDERUNG.SPEZIAL")}];
      }
    });
    this.landList = this.enumHelperService.getLandOptionList();
  }

  setBenutzer(){
    if (sessionStorage.getItem('user')) {
      this.benutzer = JSON.parse(sessionStorage.getItem('user')) as BenutzerDTO;
      this.benutzerRoles = this.benutzer.roles;
    }
  }

  loadFieldConfig(){
    this.fieldConfig = this.fieldConfigService.getFieldConfigFromSessionStorage(['fahrkosten']);
    if(!this.fieldConfig || this.fieldConfig.length <1){
      console.log('No fieldConfig for Fahrkosten found: setting default values');
      this.setFieldConfigDefault();
    }
  }

  //for validation
  visibleFields:            string[] = [];  //all fields set to visible via fieldConfig, static: loaded once on init
  //fieldConfigValidators :   string[] = [];  //all fields forced to validate via fieldConfig, static: loaded once on init

  alwaysVisible : string[] = ['schule'];
  alwaysValidateIfVisible:  string[] = ['schule','kosten','entfernung'];  //if visible = override fieldConfig and force validation, static: loaded once on init


  requiredFields: string[] = []; // fieldConfigValidators MINUS NEVER validate PLUS ALWAYS validate

  neverValidate : string[] =                // never validate these fields regardless of config, for example optional checkmarks
    [
      'sonderfallEnabled','bezugAsylbewerberleistungsgesetz',
      'adresszusatz','kontoinhaberAdresszusatz','vormundAdresszusatz','praktikumAdresszusatz',
      'praktikumHinweis', 'isVormundadresseAbweichend',
      'textbausteinId',
      'sonderfall',
      'isKontoinhaberAbweichend', 'isBerufskolleg','sonderfallSchuleAusserhalb',
      'sonderfallSchulungsmoeglichkeit','sonderfallFamilienheimfahrten',
      'mitfahrerBei'
    ];

  effectiveValidators: string[]  = [];  //the validators that become effective if you try EINREICHEN

  // Felder die optional sichtbar sind, wenn eine der folgenden Optionen gewählt wird:

  //vormund
  vormundOnOff = ['vormundName', 'vormundVorname','vormundGeburtsdatum','vormundTelefonnummer','vormundEmail','vormundGeschlecht',];
  vormundAdresseAbweichendOnOff = ['vormundStrasse','vormundOrt','vormundPlz','vormundLand','vormundAdresszusatz'];

  //wegtyp
  schulwegOnOff   = ['unterrichtszeitVon','unterrichtszeitBis'];
  praktikumOnOff  = ['praktikumHinweis','praktikumStrasse','praktikumOrt','praktikumPlz','praktikumLand',
    'praktikumStartdatum','praktikumEnddatum','praktikumstageJeWoche','praktikumsvertrag','praktikumAdresszusatz', 'praktikumStelle'];
  beidesOnOff     = ['schultageJeWoche'];

  //schultyp
  schuleOnOff = ['schuljahr','klasse',];
  berufskollegOnOff = ['schuljahr','bildungsgang','bildungsgangdatum','fachbereich'];

  //befoerderung bei fahrkosten
  mitfahrerOnOff = ['mitfahrerBei'];
  pkwOnOff = ['kennzeichen'];
  oepnvOnOff = [];

  //sonderfälle
  sonderfallOnOff = ['sonderfallNachweis'];
  sonderfallSonstOnOff = ['sonderfallBegruendung'];

  asylOnOff = ['bezugNachweis'];

  // konto
  kontoinhaberOnOff = ['kontoinhaberName','kontoinhaberVorname',
    'kontoinhaberStrasse','kontoinhaberOrt','kontoinhaberPlz',
    'kontoinhaberAdresszusatz','kontoinhaberLand','kontoinhaberGeburtsdatum',];

  setFieldConfigDefault() {
    this.fieldConfig = [
      //schueler
      {field: 'vorname', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'name', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'strasse', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'plz', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'ort', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'adresszusatz', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'land', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'geburtsdatum', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'email', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'emailSchueler', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'telefonnummer', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'geschlecht', visible: true, required: false, label: null, module: 'fahrkosten'},
      //vormund
      {field: 'vormundVorname', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'vormundName', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'isVormundadresseAbweichend', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'vormundStrasse', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'vormundPlz', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'vormundOrt', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'vormundLand', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'vormundAdresszusatz', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'vormundGeburtsdatum', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'vormundEmail', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'vormundTelefonnummer', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'vormundGeschlecht', visible: true, required: false, label: null, module: 'fahrkosten'},
      //konto
      {field: 'iban', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'bic', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'isKontoinhaberAbweichend', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'kontoinhaberVorname', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'kontoinhaberName', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'kontoinhaberStrasse', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'kontoinhaberOrt', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'kontoinhaberPlz', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'kontoinhaberAdresszusatz', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'kontoinhaberLand', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'kontoinhaberGeburtsdatum', visible: true, required: false, label: null, module: 'fahrkosten'},
      //erstattung
      {field: 'wegtyp', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'erstattungszeitraumVon', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'erstattungszeitraumBis', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'krankheitstage', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'fehltage', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'befoerderung', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'mitfahrerBei', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'kennzeichen', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'kosten', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'entfernung', visible: true, required: false, label: null, module: 'fahrkosten'},
      //schule
      {field: 'schule', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'schuljahr', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'klasse', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'bildungsgang', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'bildungsgangdatum', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'fachbereich', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'schultageJeWoche', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'unterrichtszeitVon', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'unterrichtszeitBis', visible: true, required: false, label: null, module: 'fahrkosten'},
      //praktikum
      {field: 'praktikumHinweis', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'praktikumStelle', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'praktikumStrasse', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'praktikumOrt', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'praktikumPlz', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'praktikumLand', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'praktikumAdresszusatz', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'praktikumStartdatum', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'praktikumEnddatum', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'praktikumstageJeWoche', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'praktikumsvertrag', visible: true, required: false, label: null, module: 'fahrkosten'},
      // sonderfall
      {field: 'sonderfallEnabled', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'sonderfall', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'sonderfallBegruendung', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'sonderfallSchuleAusserhalb', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'sonderfallSchulungsmoeglichkeit', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'sonderfallFamilienheimfahrten', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'sonderfallNachweis', visible: true, required: false, label: null, module: 'fahrkosten'},
      // bezug
      {field: 'bezugAsylbewerberleistungsgesetz', visible: true, required: false, label: null, module: 'fahrkosten'},
      {field: 'bezugNachweis', visible: true, required: false, label: null, module: 'fahrkosten'},
      // datenschutz
      {field: 'acceptTerms', visible: true, required: false, label: null, module: 'fahrkosten'},
      // fahrkostenKosten
      {field: 'fahrkostenKostenUniversal', visible: true, required: false, label: null, module: 'fahrkosten'},
      // neu
      {field: 'fahrkostenNachweis', visible: true, required: false, label: null, module: 'fahrkosten'},

    ];
  }

  fahrkostenFormFields  = [
    // Felder die ohne Umwege direkt von antragTicketDTO in antragTicketForm geladen werden können.
    'vorname','name','strasse','plz','ort','adresszusatz','land','geburtsdatum',
    'email','emailSchueler','telefonnummer','geschlecht',

    //vormund
    'vormundName', 'vormundVorname','isVormundadresseAbweichend',
    'vormundStrasse','vormundOrt','vormundPlz', 'vormundAdresszusatz',
    'vormundLand', 'vormundGeburtsdatum', 'vormundTelefonnummer', 'vormundEmail','vormundGeschlecht',

    //konto
    'iban','bic','isKontoinhaberAbweichend','kontoinhaberName','kontoinhaberVorname',
    'kontoinhaberStrasse','kontoinhaberOrt','kontoinhaberPlz',
    'kontoinhaberAdresszusatz','kontoinhaberLand','kontoinhaberGeburtsdatum',

    //erstattung
    'wegtyp', 'erstattungszeitraumVon','erstattungszeitraumBis','befoerderung',
    'fehltage','krankheitstage', 'mitfahrerBei','kennzeichen','kosten','entfernung',

    //schule
    'schule','isBerufskolleg','schuljahr','klasse','bildungsgang','bildungsgangdatum','fachbereich', 'schultageJeWoche',
    'unterrichtszeitVon','unterrichtszeitBis',

    //praktikum
    'praktikumHinweis','praktikumStelle', 'praktikumStrasse','praktikumPlz','praktikumOrt','praktikumLand','praktikumAdresszusatz',
    'praktikumStartdatum','praktikumEnddatum','praktikumstageJeWoche','praktikumsvertrag','praktikumsvertragId',

    //sonderfall
    'sonderfallEnabled','sonderfall','sonderfallBegruendung',
    'sonderfallSchuleAusserhalb','sonderfallSchulungsmoeglichkeit','sonderfallFamilienheimfahrten',
    'sonderfallNachweis','sonderfallNachweisId',

    //bezug
    'bezugAsylbewerberleistungsgesetz','bezugNachweis','bezugNachweisId',

    //datenschutz
    'acceptTerms',

    //fahrkosten-kosten
    'fahrkostenKostenUniversalList',

    //neu
    'fahrkostenNachweis','fahrkostenNachweisId'

  ];


}
